<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import MixinList from '@/Libs/Mixins/List.js';

export default {
    mixins: [MixinList],
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            routeName: 'permission-group',
        }
    },
    methods: {
        async _search() {
            var search = this.search;

            if (!search.order_by) {
                search.order_by = 'name';
                search.sort_by = 'asc';
            }

            return await this.$api.PermissionGroup.all(search);
        },
        async _delete(params) {
            return await this.$api.PermissionGroup.delete(params)
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('permission_group.title.list')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow class="g-4 align-items-center mb-3">
            <BCol sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                    <BButton type="button" variant="success" class="add-btn" id="add-btn"
                        v-if="$ac.hasAccess('permission_group_create')" :to="{ name: 'permission-group-create' }">
                        <i class="mdi mdi-plus-thick align-bottom me-1"></i> {{ $t('basic.btn.add') }}
                    </BButton>
                </div>
            </BCol>
        </BRow>

        <BRow>
            <BCol lg="12">
                <BCard no-body>
                    <BCardBody>
                        <div>
                            <div class="table-responsive table-card position-relative">
                                <loading :loading="$loading.get([routeName, 'list'].join('_'))" variant="dark"
                                    type="block">
                                    <table class="table align-middle table-hover table-nowrap mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                                                <th class="cursor-pointer" @click="sortBy('name')">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        {{ $t('permission_group.label.name') }}
                                                        <sortable :order="$orderBy.getClass('name')" />
                                                    </div>
                                                </th>
                                                <th style="width: 150px;">{{ $t('basic.label.action') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tr, index) in list" :key="index" @click="$ac.hasAccess('permission_group_show') &&
                                                $router.push({ name: 'permission-group-detail', params: { id: tr.id } })"
                                                class="cursor-pointer">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ tr.name }}</td>
                                                <td @click.stop>
                                                    <BDropdown variant="primary" no-caret size="md" strategy="fixed">
                                                        <template #button-content
                                                            class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                                                            {{
                                                                $t('basic.btn.action') }} </template>
                                                        <BDropdownItem @click.prevent="destroy(tr.id)" variant="danger"
                                                            v-if="$ac.hasAccess('permission_group_delete')">
                                                            <i class="mdi mdi-eraser fs-16"></i> {{
                                                                $t('basic.btn.delete') }}
                                                        </BDropdownItem>
                                                    </BDropdown>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </loading>
                            </div>
                        </div>
                    </BCardBody>
                </BCard>
            </BCol>
        </BRow>
        <BRow class="mb-3">
            <BCol>
                <div>
                    <pagination v-bind:model="paginator" v-on:goto="goto"
                        :disabled="$loading.get([routeName, 'list'].join('_'))" />
                </div>
            </BCol>
        </BRow>
    </Layout>
</template>